import { createItemSet } from 'tabview/visualizations/aq-blocks/itemSet';
import {
  BlocksVisualState,
  type BlocksGraph,
  type BlocksNode,
  type ItemSet,
} from 'tabview/visualizations/aq-blocks/types';
import { getVisibleDescendants } from 'tabview/visualizations/aq-blocks/util';

const hasLabelContaining =
  (normalizedQuery: string) =>
  (node: BlocksNode): boolean =>
    node.labels.some(label =>
      label.toLocaleLowerCase().includes(normalizedQuery)
    );

/**
 * The visible nodes with a label containing `query`, ignoring case and the
 * query's surrounding whitespace. Nodes inside closed groups are not searched.
 */
export const findNode = (graph: BlocksGraph, query: string): ItemSet => {
  const items = createItemSet(BlocksVisualState.None);
  const normalizedQuery = query.trim().toLocaleLowerCase();

  if (normalizedQuery.length === 0) return items;

  const matches = hasLabelContaining(normalizedQuery);

  for (const node of getVisibleDescendants(graph.root)) {
    if (matches(node)) {
      items.add(node);
    }
  }

  return items;
};
